exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".el-table__body,.el-table__header{width:100%!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-6265995e!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/views/OperationManage/Dynamics/ReportManage/ReportManage.vue
// module id = 551
// module chunks = 0